exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content {\n  background: #e5e9ec;\n  padding: 0;\n  padding-top: 61px;\n  margin: 0;\n  float: left;\n  width: 100%;\n  min-height: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/main/main.component.scss
// module id = ../../../../../src/app/main/main.component.scss
// module chunks = 1